import React, { useState } from 'react';

const WizardRating = ({ value, onChange, min = 1, max = 6, className = '' }) => {
  const [hovered, setHovered] = useState(null);
  const nums = Array.from({ length: max - min + 1 }, (_, i) => min + i);

  return (
    <div className={`flex flex-wrap gap-4 justify-center ${className}`}>
      {nums.map(n => {
        const isSelected = value === n;
        const isHovered = hovered === n;
        const active = isSelected || isHovered;
        return (
          <button
            key={n}
            type="button"
            onClick={() => onChange?.(n)}
            onMouseEnter={() => setHovered(n)}
            onMouseLeave={() => setHovered(null)}
            className={`relative w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 rounded-2xl border-2 transition-all duration-200 flex items-center justify-center text-4xl md:text-5xl lg:text-6xl font-bold transform hover:scale-105 active:scale-95 ${active ? 'border-succession-primary bg-succession-primary text-white shadow-succession-md' : 'border-succession-border bg-white text-succession-foreground hover:border-succession-border-hover'}`}
          >
            {n}
            {isSelected && (
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white shadow-sm" />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default WizardRating;


